import { DataStoreVariableType } from '@doss/prisma/types'

/**
 * Datastore mutations that operate on numbers
 */
export enum DatastoreNumberMutationOperation {
  ADD = 'add',
  SUBTRACT = 'subtract',
  MULTIPLY = 'multiply',
  SET = 'set',
}

/**
 * Datastore mutations that operate on strings
 */
export enum DatastoreStringMutationOperation {
  APPEND = 'append',
  PREPEND = 'prepend',
  SET = 'set',
}

/**
 * Datastore mutations that operate on arrays
 */
export enum DatastoreArrayMutationOperation {
  PUSH = 'push',
  REMOVE = 'remove',
  CLEAR = 'clear',
}

/**
 * Datastore mutations that operate on booleans
 */
export enum DatastoreBooleanMutationOperation {
  SET = 'set',
}

/**
 * All datastore mutation operations
 */
export type DatastoreMutationOperation =
  | DatastoreNumberMutationOperation
  | DatastoreStringMutationOperation
  | DatastoreArrayMutationOperation
  | DatastoreBooleanMutationOperation

export function checkOperationForDatastoreVariableType(
  operation: DatastoreMutationOperation,
  variableType: DataStoreVariableType,
): boolean {
  switch (variableType) {
    case DataStoreVariableType.ARRAY_NUMBER:
      return Object.values(DatastoreArrayMutationOperation).includes(
        operation as DatastoreArrayMutationOperation,
      )
    case DataStoreVariableType.ARRAY_STRING:
      return Object.values(DatastoreArrayMutationOperation).includes(
        operation as DatastoreArrayMutationOperation,
      )
    case DataStoreVariableType.NUMBER:
      return Object.values(DatastoreNumberMutationOperation).includes(
        operation as DatastoreNumberMutationOperation,
      )
    case DataStoreVariableType.STRING:
      return Object.values(DatastoreStringMutationOperation).includes(
        operation as DatastoreStringMutationOperation,
      )
    case DataStoreVariableType.BOOLEAN:
      return Object.values(DatastoreBooleanMutationOperation).includes(
        operation as DatastoreBooleanMutationOperation,
      )
  }
  return false
}

/**
 * All datastore mutation operations
 */
export const ALL_DATASTORE_MUTATION_OPERATIONS: DatastoreMutationOperation[] = [
  ...Object.values(DatastoreNumberMutationOperation),
  ...Object.values(DatastoreStringMutationOperation),
  ...Object.values(DatastoreArrayMutationOperation),
  ...Object.values(DatastoreBooleanMutationOperation),
] as const
